import { useTranslation } from 'react-i18next';

import type { StageRunStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';

const TONE: Record<StageRunStatus, string> = {
  pending: 'border-border text-muted-foreground',
  in_progress: 'bg-primary/10 text-foreground border-transparent',
  waiting_customer: 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  completed: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  skipped: 'border-border text-muted-foreground',
  stopped: 'bg-destructive/10 text-destructive border-transparent',
};

export function StageStatusBadge({ status }: { status: StageRunStatus }) {
  const { t } = useTranslation('production');
  return (
    <Badge variant="outline" className={TONE[status]}>
      {t(`status.${status}`)}
    </Badge>
  );
}

export function DelayedBadge() {
  const { t } = useTranslation('production');
  return (
    <Badge variant="outline" className="bg-destructive/10 text-destructive border-transparent">
      {t('delayed')}
    </Badge>
  );
}
